import { useContext, useEffect, useState } from "react";
import { AppContext } from "@/App";
import api from "@/lib/api";
import { ShieldCheck, BadgeCheck, Clock, Lock, Star } from "lucide-react";

const ICONS = [BadgeCheck, ShieldCheck, Clock, Lock];

export default function Trust() {
  const { t, lang } = useContext(AppContext);
  const [summary, setSummary] = useState(null);
  const [liveReviews, setLiveReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews").then((r) => setLiveReviews(r.data)).catch(() => {});
    api.get("/reviews/summary").then((r) => setSummary(r.data)).catch(() => {});
  }, []);

  const reviews = liveReviews.length
    ? liveReviews.map((r) => ({ name: r.name, text: r.text, rating: r.rating, live: true }))
    : t.trust.reviews.map((r) => ({ ...r, rating: 5 }));
  return (
    <section className="mx-auto max-w-7xl px-4 py-24 sm:px-6">
      <p className="label-accent">03 — {t.trust.label}</p>
      <h2 className="font-display mt-3 max-w-2xl text-3xl font-medium text-amber-100/90 sm:text-4xl">{t.trust.title}</h2>
      {summary && summary.count > 0 && (
        <div data-testid="reviews-summary-badge" className="mt-5 inline-flex items-center gap-2 rounded-full border border-[rgba(212,175,55,0.3)] px-4 py-1.5">
          <Star className="h-4 w-4 fill-[#D4AF37] text-[#D4AF37]" />
          <span className="font-code text-sm font-medium text-[#E5C158]">{String(summary.avg).replace(".", ",")}</span>
          <span className="text-xs text-neutral-400">· {summary.count} {lang === "it" ? "recensioni verificate" : "verified reviews"}</span>
        </div>
      )}

      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {t.trust.points.map((p, i) => {
          const Icon = ICONS[i];
          return (
            <div key={p.title} data-testid={`trust-point-${i}`} className="border-l-2 border-[rgba(212,175,55,0.3)] pl-5">
              <Icon className="mb-3 h-6 w-6 text-[#D4AF37]" />
              <h3 className="font-display text-lg font-semibold text-white">{p.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-neutral-400">{p.desc}</p>
            </div>
          );
        })}
      </div>

      <p className="label-accent mt-20">{t.trust.reviewsLabel}</p>
      <div className="mt-6 grid gap-5 md:grid-cols-3">
        {reviews.map((r, idx) => (
          <figure key={`${r.name}-${idx}`} data-testid={`review-${r.name.replace(/[^a-z]/gi, "").toLowerCase()}`} className="card-surface p-6">
            <div className="mb-3 flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className={`h-3.5 w-3.5 ${i < r.rating ? "fill-[#D4AF37] text-[#D4AF37]" : "text-neutral-700"}`} />
              ))}
            </div>
            <blockquote className="text-sm leading-relaxed text-neutral-300">“{r.text}”</blockquote>
            <figcaption className="mt-4 font-code text-xs uppercase tracking-widest text-[#E5C158]">
              {r.name}{r.live && <span className="ml-2 text-neutral-600">· verificata</span>}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
